// extracted by mini-css-extract-plugin
export var description = "description_P0Slzm9r_FIQ4M_NRUBK";
export var setupCompleteContainer = "setup-complete-container_P8fb3qpRfe7LrFBWQ8Aw";
export var successIcon = "success-icon_gZJGbVIlel7OjCFEpwf4";